import { HTTP } from '@/lib/http/client';

export default class AppConfigApi {
  static async uploadFile(base64String: string): Promise<string> {
    const res = await HTTP.post('files', { file: base64String });
    return res.data.fileToken;
  }
}
